import { createSlice } from "@reduxjs/toolkit";

const selectedCustomerSlice = createSlice({
  name: "selectedCustomer",
  initialState: null,
  reducers: {
    setSelectedCustomer: (state, action) => {
      return action.payload;
    },
    clearSelectedCustomer: () => {
      return null;
    },
  },
});

export const { setSelectedCustomer, clearSelectedCustomer } =
  selectedCustomerSlice.actions;
export const selectedSelectedCustomer = (state) => state.selectedCustomer;

export default selectedCustomerSlice.reducer;
